<template>
  <!-- Features Section Start -->
  <section id="forms" class="section-padding">
    <div class="container" >
      <div class="section-header text-center">
        <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s" >فرم ها و دستورالعمل های آموزشی</h2>
        <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
      </div>
      <div class="row" >
        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
          <h3 class="text-center"> دکترا</h3>
          <div class="content-left">
            <div class="box-item wow fadeInLeft mrBoxShadowNun" data-wow-delay="0.3s">
              <div class="text d-flex">
                <span class="icon">
                  <i class="lni-layers " style="font-size: 3rem;"></i>
                </span>
                <ul>
                  <li v-for="(item,id) in doctors " :key="id">
                    <i class="lni lni-more-alt text-green "></i>
                    <a :href="'/doc/'+item.link" >
                      {{item.title}}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
          <div class="show-box wow fadeInUp" data-wow-delay="0.3s">
            <img class="img-fluid" src="../assets/img/forms.png" alt="فرم ها">
          </div>
        </div>
        <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
          <h3 class="text-center"> کارشناسی ارشد</h3>
          <div class="content-right">
            <div class="box-item wow fadeInRight mrBoxShadowNun" data-wow-delay="0.3s">
              <div class="text d-flex">
                <span class="icon">
                  <i class="lni lni-bi-cycle " style="font-size: 3rem;"></i>
                </span>
                <ul>
                  <li v-for="(master , id) in masters" :key="id">
                    <i class="lni lni-more-alt text-green "></i>
                    <a :href="'/doc/'+master.link" >
                    {{master.title}}
                  </a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-header text-center mt-4">
        <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s"> فرم ها و دستورالعمل های آموزشی مشترک</h2>
        <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="content-left">
            <div class="box-item wow fadeInLeft" data-wow-delay="0.3s">
              <div class="text d-flex">
                <span class="icon">
                  <i class="lni-leaf" style="font-size: 3rem;"></i>
                </span>
                <ul>
                  <li v-for="(itemCommon,id) in commons " :key="id"><i class="lni lni-more-alt text-green "></i>
                    <a :href="'/doc/'+itemCommon.link" >
                      {{itemCommon.title}}
                    </a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Features Section End -->

</template>
<script>
import {master,doctor,common} from "../Data/formData";
export default {
  name: "Forms",
  data (){
    return{
      masters:master,
      doctors:doctor,
      commons:common,
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/color";
ul li{
  //list-style: disc !important;
  margin-bottom: 5px;
  text-align: right;
}
ul li a{
  color: $green;
  padding-bottom: 10px;
  padding-right: 10px;
  position: relative;
  top:-3px;
}
h3{
  font-size: 1.5rem;
}

.mrBoxShadowNun {
  box-shadow: none !important;
}
</style>